import {styled} from '@core-ui/react-stitch';

const DrawerMiddleSection = styled.section(({isBRRedesignEnabled}) => ({
  width: '100%',
  overflowY: isBRRedesignEnabled ? 'auto' : 'scroll',
}));

export default DrawerMiddleSection;
